import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/event/springPromotionEvent2026.ts
const lotteryRewardStatusEnum = ["LOCKED", "CLAIMED"];
const progressRewardsSchema = z.object({
	p7: z.enum(lotteryRewardStatusEnum),
	p12: z.enum(lotteryRewardStatusEnum),
	p17: z.enum(lotteryRewardStatusEnum),
	p20: z.enum(lotteryRewardStatusEnum),
	p25: z.enum(lotteryRewardStatusEnum)
});
const statusOutputSchema = z.object({
	rollCount: z.int().min(0),
	eventTokenCount: z.int().min(0),
	ownedCardCodes: z.array(z.string()),
	srPityCount: z.int().min(0),
	ssrPityCount: z.int().min(0),
	srPityRemaining: z.int().min(0),
	ssrPityRemaining: z.int().min(0),
	uniqueCount: z.int().min(0),
	progressRewardsClaimed: progressRewardsSchema,
	dailyFreeClaimAvailable: z.boolean(),
	dailyFreeClaimedToday: z.int().min(0),
	grandGuaranteeRemaining: z.int(),
	hasCollectedAllCards: z.boolean(),
	completedChapterIds: z.array(z.string())
});
const claimFreePullsOutputSchema = z.object({ granted: z.int().min(0) });
const completeChapterInputSchema = z.object({ chapterId: z.string() });
const completeChapterOutputSchema = z.object({
	alreadyCompleted: z.boolean(),
	grantedKaisuuken: z.int().min(0)
});
const chapterCompletionSchema = z.object({
	chapterId: z.string(),
	completedAt: z.iso.datetime()
});
const chapterCompletionsOutputSchema = z.object({ chapters: z.array(chapterCompletionSchema) });
const grantTokensInputSchema = z.object({ amount: z.int().min(1).max(1e4) });
const springPromotionEvent2026Contract = oc.prefix("/event/spring-promotion-2026").tag("SpringPromotionEvent2026").router({
	status: oc.route({
		method: "GET",
		path: "/status",
		summary: "Get Spring Promotion 2026 lottery status for current user"
	}).output(statusOutputSchema.nullable()),
	claimFreePulls: oc.route({
		method: "POST",
		path: "/claim-free-pulls",
		summary: "Claim daily free pulls for Spring Promotion 2026"
	}).output(claimFreePullsOutputSchema),
	completeChapter: oc.route({
		method: "POST",
		path: "/complete-chapter",
		summary: "Mark a drama chapter as completed and grant rewards"
	}).input(completeChapterInputSchema).output(completeChapterOutputSchema),
	chapterCompletions: oc.route({
		method: "GET",
		path: "/chapter-completions",
		summary: "List drama chapters the current user has completed"
	}).output(chapterCompletionsOutputSchema),
	dailyCheckIn: oc.route({
		method: "POST",
		path: "/daily-check-in",
		summary: "Trigger daily check-in quest for Spring Promotion 2026"
	}),
	grantTokens: oc.route({
		method: "POST",
		path: "/grant-tokens",
		summary: "Grant event tokens to the caller (admin/debug)"
	}).input(grantTokensInputSchema)
});
//#endregion
export { chapterCompletionSchema, springPromotionEvent2026Contract };
